module.exports = __webpack_public_path__ + "media/images/playlog-icon-57777024350501432496c35a15e9b040.svg";